export default __webpack_public_path__ + "static/media/pleading-face.1bf148dd.png";